import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function BookingWidgetManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('bookingWidget:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const bookingWidgetSchema = {
    name: { label: 'Name', type: 'text', required: true, minWidth: '220px' },
    description: {
      label: 'Beschreibung',
      type: 'text',
      required: false,
      minWidth: '360px',
      previewInList: true,
      previewMaxLines: 3,
      useHyphens: true,
    },
    linkedProduct: {
      label: 'Verknüpftes Produkt',
      type: 'select',
      api: {
        resource: 'product',
        labelField: 'name',
        valueField: '_id',
        skipSpecial: true,
      },
      placeholder: 'Produkt auswählen',
      required: true,
    },
    linkedEntertainments: {
      label: 'Verknüpfte Entertainments',
      type: 'multi-select',
      api: {
        resource: 'entertainment',
        labelField: 'longName',
        valueField: '_id',
        skipSpecial: true,
      },
      placeholder: 'Entertainments auswählen',
      required: true,
    },
    allowedPricingIds: {
      label: 'Erlaubte Preislisten',
      type: 'multi-select',
      api: {
        resourceById: 'product',
        dependentIdField: 'linkedProduct',
        path: 'pricing',
        labelField: 'list',
        valueField: '_id',
      },
      placeholder: 'Preislisten auswählen (leer = alle)',
      required: false,
      minWidth: '260px',
      listDisplayValue: values => {
        if (!Array.isArray(values) || values.length === 0) {
          return 'Alle Preislisten';
        }
        return `${values.length} Preislisten ausgewählt`;
      },
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={bookingWidgetSchema}
      title='Neues Booking-Widget anlegen'
      resourceType='bookingWidget'
      headerSearchPlaceholder='Booking Widgets durchsuchen'
      parentIsEditable={authCtx.checkRight('bookingWidget:update')}
      options={{ titleKey: 'name' }}
    />
    </Box>
  );
}

export default BookingWidgetManagement;
